import React from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Headers from './Component/Header';
import Footer from './Component/Footer';
import Request from './Component/requestEstimate';
import img4861 from './Component/home/4861.jpg';
import img4862 from './Component/home/4862.jpg';
import img4863 from './Component/home/4863.jpg';
import img4864 from './Component/home/4864.jpg';
import img4865 from './Component/home/4865.jpg';
import img4866 from './Component/home/4866.jpg';
import img4867 from './Component/home/4867.jpg';
import img4869 from './Component/home/4869.jpg';

const products = [
  { icon: 'bi-door-closed', label: 'Cabinets' },
  { icon: 'bi-tools', label: 'Cabinet Hardware' },
  { icon: 'bi-droplet', label: 'Vanities' },
  { icon: 'bi-cup-straw', label: 'Sinks' },
  { icon: 'bi-moisture', label: 'Faucets' },
  { icon: 'bi-water', label: 'Tubs' },
  { icon: 'bi-house-door', label: 'Toilets' },
  { icon: 'bi-shower', label: 'Custom Showers' },
  { icon: 'bi-grid-3x3', label: 'All Types of Floors' },
];

const gallery = [
  {
    src: img4869,
    title: 'Kitchen Displays',
    text: 'Cabinets, countertops, sinks, faucets, and appliances styled for real homes.',
    alt: 'Kitchen showroom with cabinets, counters, and farmhouse sink',
  },
  {
    src: img4861,
    title: 'Farmhouse Sink & Faucet',
    text: 'Stainless apron-front sinks with modern matte black faucets.',
    alt: 'Farmhouse sink and matte black faucet in kitchen display',
  },
  {
    src: img4862,
    title: 'Full Kitchen Suite',
    text: 'Two-tone cabinetry, stone counters, and textured tile backsplash.',
    alt: 'Complete modern kitchen display with cabinets and appliances',
  },
  {
    src: img4863,
    title: 'Coffee Station Cabinetry',
    text: 'Custom cabinet layouts with sleek hardware and stone tops.',
    alt: 'Kitchen coffee station with charcoal cabinets and black hardware',
  },
  {
    src: img4864,
    title: 'Island, Vanity & Hardware',
    text: 'Kitchen islands, bath vanities, sinks, and Jeffrey Alexander hardware.',
    alt: 'Showroom with kitchen island, vanity, and hardware display',
  },
  {
    src: img4865,
    title: 'Freestanding Tubs',
    text: 'Soaking tubs and floor-mounted fillers for a spa-like bath.',
    alt: 'Freestanding bathtub and floor-mounted faucet display',
  },
  {
    src: img4867,
    title: 'Islands & Cabinetry',
    text: 'Explore modern cabinet finishes and layouts for kitchens and baths.',
    alt: 'Kitchen island and cabinetry in our showroom',
  },
  {
    src: img4866,
    title: 'Cabinet Hardware',
    text: 'Knobs and pulls from Jeffrey Alexander by Hardware Resources and more.',
    alt: 'Jeffrey Alexander cabinet hardware display',
  },
];

function KitchenBathShowroom() {
  return (
    <div className="bg-gray-50 min-h-screen">
      <Headers />

      <section
        className="relative bg-cover bg-center"
        style={{ backgroundImage: `url(${img4862})` }}
      >
        <div className="absolute inset-0 bg-[#803333]/80" />
        <div className="relative container mx-auto px-4 py-14 md:py-20 text-center text-white">
          <p className="text-xs font-semibold uppercase tracking-wider text-white/80 mb-2">
            Now Open
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-2 tracking-tight">
            New Kitchen & Bath Showroom
          </h1>
          <p className="text-white/85 text-sm md:text-base mb-6 max-w-2xl mx-auto">
            Cabinets, hardware, vanities, sinks, faucets, tubs, toilets, custom showers — and all types of floors
          </p>
          <a
            href="/free-estimate"
            className="inline-flex items-center gap-2 bg-white text-[#803333] font-semibold text-sm px-5 py-2.5 rounded-lg no-underline hover:bg-white/90 transition-colors"
          >
            Request an Estimate
            <i className="bi bi-arrow-right" />
          </a>
        </div>
      </section>

      <section className="container mx-auto px-4 py-10 md:py-14">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
            Visit our expanded showroom
          </h2>
          <p className="text-gray-600 text-sm md:text-base max-w-2xl mx-auto m-0">
            Stop by Nickle&apos;s Flooring in Cassville to see kitchen and bath displays in person — including Jeffrey Alexander cabinet hardware and complete kitchen suites.
          </p>
        </div>

        <div className="row g-4 mb-10">
          {gallery.map((item) => (
            <div key={item.title} className="col-6 col-md-4 col-lg-3">
              <div className="overflow-hidden rounded-2xl shadow-sm border border-gray-100 bg-white h-100">
                <img
                  src={item.src}
                  alt={item.alt}
                  className="w-full aspect-[4/5] object-cover"
                />
                <div className="p-3 md:p-4">
                  <h3 className="text-sm md:text-base font-bold text-gray-900 mb-1">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-gray-600 m-0">{item.text}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 md:p-8 mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-2 text-center">
            Products we now sell
          </h2>
          <p className="text-gray-600 text-sm text-center mb-6 max-w-xl mx-auto">
            Everything you need for kitchen and bath projects — plus the flooring we&apos;ve always been known for.
          </p>
          <div className="row g-3">
            {products.map((item) => (
              <div key={item.label} className="col-6 col-md-4 col-lg-3">
                <div className="flex items-center gap-3 rounded-xl border border-gray-100 bg-gray-50 px-3 py-3 h-100">
                  <span className="flex-shrink-0 w-9 h-9 rounded-lg bg-[#803333]/10 text-[#803333] flex items-center justify-center">
                    <i className={`bi ${item.icon}`} />
                  </span>
                  <span className="text-sm font-semibold text-gray-800">{item.label}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="row g-4 g-lg-5 align-items-start">
          <div className="col-lg-6">
            <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
              <Request />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 md:p-8 space-y-4">
              <h2 className="text-xl md:text-2xl font-bold text-gray-900">
                Plan your kitchen or bath with us
              </h2>
              <p className="text-gray-600 text-sm md:text-base leading-relaxed m-0">
                Whether you need new cabinets and hardware, a vanity upgrade, sinks and faucets, tubs and toilets, or a fully custom waterproof shower — our team can help you design and select the right products.
              </p>
              <p className="text-gray-600 text-sm md:text-base leading-relaxed m-0">
                And of course, we still specialize in all types of floors: carpet, hardwood, luxury vinyl, tile, and more.
              </p>
              <div className="pt-2 flex flex-wrap gap-3">
                <a
                  href="/free-estimate"
                  className="inline-flex items-center gap-2 bg-[#803333] text-white font-semibold text-sm px-5 py-2.5 rounded-lg no-underline hover:bg-[#6a2a2a] transition-colors"
                >
                  Request an Estimate
                  <i className="bi bi-arrow-right" />
                </a>
                <a
                  href="tel:+14178472484"
                  className="inline-flex items-center gap-2 border-2 border-[#803333] text-[#803333] font-semibold text-sm px-5 py-2.5 rounded-lg no-underline hover:bg-[#803333]/5 transition-colors"
                >
                  <i className="bi bi-telephone" />
                  (417) 847-2484
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default KitchenBathShowroom;
